export default __webpack_public_path__ + "static/media/join.db6358f5.png";